<template>
  <a-modal
    :visible="visible"
    title="分组策略配置"
    width="627px"
    centered
    :destroy-on-close="true"
    :mask-closable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model
      ref="downForm"
      :label-col="{ span: 3 }"
      :wrapper-col="{ span: 21 }"
    >
      <a-form-model-item
        v-for="(item, index) in levelSetList"
        :key="index"
        :label="item.name + '组'"
        :prop="item.name"
      >
        <div>
          <span>知识掌握度在</span>
          <a-input-number
            v-model="item.minMastered"
            :min="item.minOne"
            :max="item.maxOne"
            :disabled="index <= 2"
            :formatter="
              value => {
                let reg = /^(-)*(\d+)\.(\d).*$/
                return `${value}`
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  .replace(reg, '$1$2.$3')
              }
            "
            :parser="
              value => {
                let reg = /^(-)*(\d+)\.(\d).*$/
                return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3')
              }
            "
            class="box-spacing"
            @change="minmasteredchange(item, index)"
          />
          <!-- {{ item.minOne }}
          {{ item.maxOne }}
          {{ item.minMastered }} -->
          <span>到</span>
          <a-input-number
            v-model="item.maxMastered"
            :min="item.minTwo"
            :max="item.maxTwo"
            :formatter="
              value => {
                let reg = /^(-)*(\d+)\.(\d).*$/
                return `${value}`
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  .replace(reg, '$1$2.$3')
              }
            "
            :parser="
              value => {
                let reg = /^(-)*(\d+)\.(\d).*$/
                return value.replace(/\s?|(,*)/g, '').replace(reg, '$1$2.$3')
              }
            "
            class="box-spacing"
            @change="maxmasteredchange(item, index)"
          />
          <!-- {{ item.minTwo }}
          {{ item.maxTwo }}
          {{ item.maxMastered }} -->
          <span>之间的学生。</span>
        </div>
        <div>
          <span>推送变式题的难度为：</span>
          <a-checkbox-group v-model="item.difficulty" class="course_item">
            <a-checkbox
              v-for="cit in difficultyList"
              :key="cit.id"
              :value="cit.id"
            >
              <span class="kemu_name">{{ cit.name }}</span>
            </a-checkbox>
          </a-checkbox-group>
        </div>
      </a-form-model-item>

      <a-form-model-item>
        <div class="master-check">
          <a-checkbox :checked="ismasterCheck" @change="ismasterchange">
            掌握度为空时，按照0推送
          </a-checkbox>
        </div>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
  export default {
    components: {},
    // props: ['treeData', 'columnsList'],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      levelSetList: {
        type: Array,
        default: () => []
      },
      ismaster: {
        type: Boolean,
        default: false
      },
      handleCancel: {
        type: Function,
        default: () => ''
      },
      handleOk: {
        type: Function,
        default: () => ''
      }
    },
    data() {
      return {
        ismasterCheck: this.ismaster,
        difficultyList: [
          {
            id: 1,
            name: '容易'
          },
          {
            id: 2,
            name: '较易'
          },
          {
            id: 3,
            name: '一般'
          },
          {
            id: 4,
            name: '较难'
          },
          {
            id: 5,
            name: '困难'
          }
        ]
      }
    },
    watch: {
      paramsData: {
        handler(val) {
          if (val.studentId && val.subjectId) {
            // 题型得分
            this.getKnowPoint()
          }
        },
        deep: true
      }
    },
    created() {},
    mounted() {},
    methods: {
      // 知识掌握度min
      minmasteredchange(val, index) {
        if (index == 3) {
          val.minOne = 0
        }
        val.maxOne = val.maxMastered - 0.1
      },
      // 知识掌握度max
      maxmasteredchange(val, index) {
        if (index == 0) {
          val.maxTwo = 100
        }
        if (index != 0) {
          val.maxTwo = this.levelSetList[index - 1].maxMastered - 0.1
          this.levelSetList[index - 1].minMastered = val.maxMastered
        }
        val.minTwo = val.minMastered + 0.1
      },
      // 掌握度复选
      ismasterchange(e) {
        this.ismasterCheck = e.target.checked
        console.log(`checked = ${e.target.checked}`)
      },
      ok() {
        let list = []
        this.$emit('changeVisible', false)
        this.$emit('ok', list)
      },
      cancel() {
        this.$emit('changeVisible', false)
      }
    }
  }
</script>

<style lang="less" scoped>
  .master-check {
    margin-left: 50px;
  }
  .box-spacing {
    margin: 0 8px;
  }
</style>
